import request from "@/core/services/request";

export function aliyunUserCertify(data) {
  return request({
    url: "/api/v1/alipay/user/certify/",
    method: "post",
    data: data,
  });
}

export function aliyunUserCertifyNotify(data) {
  return request({
    url: "/api/v1/alipay/certify/notify/",
    method: "post",
    data: data,
  });
}
